import { render, staticRenderFns } from "./AddDrug.vue?vue&type=template&id=30beca7e&scoped=true&"
import script from "./AddDrug.vue?vue&type=script&lang=js&"
export * from "./AddDrug.vue?vue&type=script&lang=js&"
import style0 from "./AddDrug.vue?vue&type=style&index=0&id=30beca7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30beca7e",
  null
  
)

export default component.exports